var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from "react";
import { Typography } from "@mui/material";
//Language Translation
import { useTranslation } from "react-i18next";
import { createCompanyLocationAction, getSalesRepBaseData, updateCompanyLocationAction, updateCompanyNoteAction } from "../../../reduxStore/actions/salesRepDataAction";
import store from "../../../reduxStore/store";
import { IS_BILLING_ADDRESS, IS_SHIPPING_ADDRESS } from "../../Constant";
import { getLoggedInRepDetailsFromSession } from "../../../services/apiServices/salesRepDataService";
import { CommonMethods } from "./../CommonMethods";
import isEqual from "lodash/isEqual";
import { useDispatch } from "react-redux";
export function UpdateCompanyDetailsBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var _f = CommonMethods(), getDefaultCompanyDetails = _f.getDefaultCompanyDetails, getDefaultCompanyLocation = _f.getDefaultCompanyLocation, renderAddress = _f.renderAddress, getAddressPayload = _f.getAddressPayload, addressValidationCheckForBilling = _f.addressValidationCheckForBilling, addressValidationCheckForShipping = _f.addressValidationCheckForShipping, getDefaultAddress = _f.getDefaultAddress;
    var durationTypesOfPayment = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.PaymentTermsTemplates;
    var customerArray = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.customerListWithMainContact;
    var CatalogProductCountList = (_d = store.getState().salesRepData) === null || _d === void 0 ? void 0 : _d.catalogProductList;
    var _g = useState(getDefaultCompanyDetails()), companyDetails = _g[0], setCompanyDetails = _g[1];
    var _h = useState(getDefaultCompanyLocation || {}), locationDetals = _h[0], setLocationDetals = _h[1];
    var _j = useState(getDefaultCompanyLocation() || {}), originalLocationDetals = _j[0], setOriginalLocationDetals = _j[1];
    var originalLocationData = useState(getDefaultCompanyLocation() || {})[0];
    var _k = useState((companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Note) || ""), editedCompanyNote = _k[0], setEditedCompanyNote = _k[1];
    var _l = useState(""), locationModal = _l[0], setlocationModal = _l[1];
    var catalogProduct = useState(CatalogProductCountList || [])[0];
    var _m = useState([]), paymentTermOptions = _m[0], setPaymentTermOptions = _m[1];
    var _o = useState(false), newCustomerModal = _o[0], setNewCustomerModal = _o[1];
    var _p = useState("isShippingAddress"), addressType = _p[0], setAddressType = _p[1];
    var _q = useState(null), catalogHoveredIconIndex = _q[0], setCatalogHoveredIconIndex = _q[1];
    var _r = useState(null), isHovered = _r[0], setIsHovered = _r[1];
    // Address const
    var _s = useState(false), addressModal = _s[0], setAddressModal = _s[1];
    var _t = useState(false), isEditAddressModal = _t[0], setIsEditAddressModal = _t[1];
    // loader & toster
    var _u = useState({ msg: "", open: false }), triggerSnackbar = _u[0], settriggerSnackbar = _u[1];
    var _v = useState(""), isSavingLocation = _v[0], setIsSavingLocation = _v[1];
    var _w = useState(false), isCreatingLocation = _w[0], setIsCreatingLocation = _w[1];
    var _x = useState(false), isUpdatingCompanyNote = _x[0], setIsUpdatingCompanyNote = _x[1];
    var _y = useState(false), allowResetFormData = _y[0], setAllowResetFormData = _y[1];
    var defaultSavedLocationKeys = {
        Note: false,
        ExternalId: false,
        ContactPersons: false,
        Catalogs: false,
        BuyerExperienceConfiguration: false,
        TaxExempt: false,
        TaxRegistrationId: false,
    };
    var _z = useState(defaultSavedLocationKeys), updatedLocationArray = _z[0], setUpdatedLocationArray = _z[1];
    useEffect(function () {
        if (durationTypesOfPayment && (durationTypesOfPayment === null || durationTypesOfPayment === void 0 ? void 0 : durationTypesOfPayment.length) > 0) {
            var filteredOptions = durationTypesOfPayment
                .filter(function (item) { return (item === null || item === void 0 ? void 0 : item.paymentTermsType) === "NET" || (item === null || item === void 0 ? void 0 : item.paymentTermsType) === "FULFILLMENT"; })
                .map(function (item) { return (item === null || item === void 0 ? void 0 : item.description) || ""; });
            setPaymentTermOptions(filteredOptions);
        }
    }, [durationTypesOfPayment]);
    useEffect(function () {
        var _a, _b;
        if ((_a = props === null || props === void 0 ? void 0 : props.singleCompanyDetails) === null || _a === void 0 ? void 0 : _a.Id) {
            setCompanyDetails(props === null || props === void 0 ? void 0 : props.singleCompanyDetails);
            setEditedCompanyNote(((_b = props === null || props === void 0 ? void 0 : props.singleCompanyDetails) === null || _b === void 0 ? void 0 : _b.Note) || "");
        }
    }, [companyDetails]);
    var isFormChanged = useMemo(function () {
        return !isEqual(locationDetals, originalLocationData);
    }, [locationDetals, originalLocationData]);
    var handleCompanyNoteChange = function (e) {
        var _a;
        var updatedNote = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.trimStart();
        if (updatedNote === null || updatedNote === undefined) {
            settriggerSnackbar({ msg: "Invalid note value received.", open: true, severity: "warning" });
            return;
        }
        setEditedCompanyNote(updatedNote);
    };
    var updateFormData = function (key, value) {
        setLocationDetals(function (prevData) {
            var _a;
            return (__assign(__assign({}, prevData), (_a = {}, _a[key] = value, _a)));
        });
        setUpdatedLocationArray(function (prevKeys) {
            var _a;
            var originalValue = originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals[key];
            var isChanged = JSON.stringify(value) !== JSON.stringify(originalValue); // Use deep compare (safe)
            return __assign(__assign({}, prevKeys), (_a = {}, _a[key] = isChanged, _a));
        });
    };
    var handleChange = function (e) {
        updateFormData(e.target.name, e.target.value);
    };
    var handleCheckboxChange = function (e) {
        updateFormData("BillingSameAsShipping", e.target.checked);
    };
    var handleLocationClick = function (locationType, location) {
        var defaultLocation = getDefaultCompanyLocation();
        setLocationDetals(defaultLocation);
        setOriginalLocationDetals(defaultLocation);
        setlocationModal(locationType);
        if (location) {
            props === null || props === void 0 ? void 0 : props.setLocationHeadingString(location === null || location === void 0 ? void 0 : location.Name);
            setLocationDetals(location);
            setOriginalLocationDetals(location);
        }
        else {
            props === null || props === void 0 ? void 0 : props.setLocationHeadingString("New location for " + (companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Name));
        }
    };
    var BackToCompanyPage = function (allow) {
        setUpdatedLocationArray(defaultSavedLocationKeys);
        if ((props === null || props === void 0 ? void 0 : props.locationHeadingString) && locationModal == "AddLocation") {
            if (isFormChanged && allow) {
                setLocationDetals(getDefaultCompanyLocation());
                handleResetCreateLocation();
            }
            else if (isFormChanged) {
                setAllowResetFormData(true);
            }
            else {
                handleResetCreateLocation();
            }
        }
        else if (props === null || props === void 0 ? void 0 : props.locationHeadingString) {
            handleResetCreateLocation();
        }
        else {
            props === null || props === void 0 ? void 0 : props.BackBtnHandle();
        }
    };
    var handlePaymentTermChange = function (newValue) {
        var matchedPaymentTerm = durationTypesOfPayment === null || durationTypesOfPayment === void 0 ? void 0 : durationTypesOfPayment.find(function (term) { return (term === null || term === void 0 ? void 0 : term.description) === newValue; });
        var newPaymentTerm = matchedPaymentTerm
            ? {
                PaymentTermsId: matchedPaymentTerm === null || matchedPaymentTerm === void 0 ? void 0 : matchedPaymentTerm.id,
                PaymentTermsName: matchedPaymentTerm === null || matchedPaymentTerm === void 0 ? void 0 : matchedPaymentTerm.description,
            }
            : null;
        updateFormData("BuyerExperienceConfiguration", newPaymentTerm);
    };
    // location level
    var handleCatalogChange = function (event) {
        var _a;
        var selectedCatalog = catalogProduct === null || catalogProduct === void 0 ? void 0 : catalogProduct.find(function (catalog) { var _a; return (catalog === null || catalog === void 0 ? void 0 : catalog.Id) === ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value); });
        if (selectedCatalog && !((_a = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Catalogs) === null || _a === void 0 ? void 0 : _a.some(function (cat) { return (cat === null || cat === void 0 ? void 0 : cat.Id) === (selectedCatalog === null || selectedCatalog === void 0 ? void 0 : selectedCatalog.Id); }))) {
            updateFormData("Catalogs", __spreadArray(__spreadArray([], locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Catalogs, true), [selectedCatalog], false));
        }
    };
    // ✅ Handle removing catalog
    var handleRemoveCatalog = function (Id) {
        var _a;
        updateFormData("Catalogs", (_a = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Catalogs) === null || _a === void 0 ? void 0 : _a.filter(function (catalog) { return (catalog === null || catalog === void 0 ? void 0 : catalog.Id) !== Id; }));
    };
    var handleAddCustomer = function (customer) {
        var newContact = {
            Id: customer === null || customer === void 0 ? void 0 : customer.CustomerId,
            DisplayName: customer === null || customer === void 0 ? void 0 : customer.ClientName,
            Email: customer === null || customer === void 0 ? void 0 : customer.CustomerMailid,
            Role: "Ordering only",
        };
        var existingContacts = (locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ContactPersons) || [];
        var alreadyExists = existingContacts === null || existingContacts === void 0 ? void 0 : existingContacts.some(function (contact) {
            var existingId = contact.Id.replace("gid://shopify/Customer/", "");
            return existingId === (newContact === null || newContact === void 0 ? void 0 : newContact.Id);
        });
        if (alreadyExists)
            return;
        // Allow only one new contact in UpdateLocation
        if (existingContacts === null || existingContacts === void 0 ? void 0 : existingContacts.some(function (contact) { var _a; return !((_a = originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.ContactPersons) === null || _a === void 0 ? void 0 : _a.some(function (orig) { return (orig === null || orig === void 0 ? void 0 : orig.Id) === (contact === null || contact === void 0 ? void 0 : contact.Id); })); })) {
            return;
        }
        var updatedContactPersons = __spreadArray(__spreadArray([], existingContacts, true), [newContact], false);
        updateFormData("ContactPersons", updatedContactPersons);
    };
    var handleRemoveCustomer = function (Id) {
        var _a;
        updateFormData("ContactPersons", (_a = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ContactPersons) === null || _a === void 0 ? void 0 : _a.filter(function (customer) { return (customer === null || customer === void 0 ? void 0 : customer.Id) !== Id; }));
    };
    var shouldShowNoteSaveReset = editedCompanyNote !== ((companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Note) || "");
    var shouldShowSaveCancelButtonsForKey = function (updateKey) {
        return (locationModal === "UpdateLocation" && (updatedLocationArray === null || updatedLocationArray === void 0 ? void 0 : updatedLocationArray[updateKey])) || false;
    };
    var shouldShowTaxSaveButtons = locationModal === "UpdateLocation" && ((updatedLocationArray === null || updatedLocationArray === void 0 ? void 0 : updatedLocationArray.TaxExempt) || (updatedLocationArray === null || updatedLocationArray === void 0 ? void 0 : updatedLocationArray.TaxRegistrationId));
    var getCustomerAddressData = function (addressType) {
        if (addressType === IS_SHIPPING_ADDRESS) {
            return renderAddress(locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ShippingAddress);
        }
        else if (addressType === IS_BILLING_ADDRESS) {
            return renderAddress(locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.BillingAddress);
        }
        return (_jsx(Typography, __assign({ variant: "body1", color: "textSecondary" }, { children: "No Address Found" })));
    };
    // Handle form reset
    var handleResetCompanyNote = function () {
        setEditedCompanyNote((companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Note) || "");
    };
    var handleResetLocationCards = function (key) {
        var _a, _b;
        if (!originalLocationDetals)
            return;
        var updatedFields = {};
        var updatedFlags = {};
        if (key === "TaxExempt") {
            updatedFields = {
                TaxExempt: originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.TaxExempt,
                TaxRegistrationId: originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.TaxRegistrationId,
            };
            updatedFlags = {
                TaxExempt: false,
                TaxRegistrationId: false,
            };
        }
        else if (key === "ContactPersons") {
            updatedFields = {
                ContactPersons: originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.ContactPersons,
            };
            updatedFlags = {
                ContactPersons: false,
            };
        }
        else {
            updatedFields = (_a = {},
                _a[key] = originalLocationDetals[key],
                _a);
            updatedFlags = (_b = {},
                _b[key] = false,
                _b);
        }
        // Update locationDetals and update flags
        setLocationDetals(function (prev) { return (__assign(__assign({}, prev), updatedFields)); });
        setUpdatedLocationArray(function (prev) { return (__assign(__assign({}, prev), updatedFlags)); });
    };
    var handleResetCreateLocation = function () {
        setlocationModal(""); // Close modal
        props === null || props === void 0 ? void 0 : props.setLocationHeadingString("");
    };
    // Handle opening modal
    var handleAddressModal = function (type, isEdit) {
        setAddressType(type);
        setAddressModal(true);
        setIsEditAddressModal(isEdit || false);
    };
    // Handle closing modal
    var closeAddressModal = function () {
        setAddressModal(false);
        setIsEditAddressModal(false);
    };
    var handleNewCustomerModal = function () {
        setNewCustomerModal(!newCustomerModal);
    };
    var handleCloseSnackbar = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        settriggerSnackbar({ msg: "", open: false });
    };
    var isDisabledContactPersons = (_e = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ContactPersons) === null || _e === void 0 ? void 0 : _e.some(function (person) { var _a; return !((_a = originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.ContactPersons) === null || _a === void 0 ? void 0 : _a.some(function (orig) { return (orig === null || orig === void 0 ? void 0 : orig.Id) === (person === null || person === void 0 ? void 0 : person.Id); })); });
    function getResourceNoForUpdateKey(updateKey) {
        switch (updateKey) {
            case "Note":
                return "10";
            case "ExternalId":
                return "9";
            case "ShippingAddress":
            case "BillingAddress":
                return "6";
            case "ContactPersons":
                return "12";
            case "Catalogs":
                return "7";
            case "BuyerExperienceConfiguration":
                return "8";
            case "TaxExempt":
                return "11";
            default:
                return "";
        }
    }
    var buildCatalogUpdatePayloads = function (updatedLocation) {
        var _a, _b, _c, _d;
        var originalCatalogIds = new Set((_a = originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.Catalogs) === null || _a === void 0 ? void 0 : _a.map(function (c) { return c.Id; }));
        var updatedCatalogIds = new Set((_b = updatedLocation.Catalogs) === null || _b === void 0 ? void 0 : _b.map(function (c) { return c.Id; }));
        var payloads = [];
        // Added catalogs
        (_c = updatedLocation.Catalogs) === null || _c === void 0 ? void 0 : _c.forEach(function (catalog) {
            if (!originalCatalogIds.has(catalog.Id)) {
                payloads.push({
                    catalogId: catalog.Id,
                    contextsToAdd: {
                        companyLocationIds: [updatedLocation.Id],
                    },
                });
            }
        });
        // Removed catalogs
        (_d = originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.Catalogs) === null || _d === void 0 ? void 0 : _d.forEach(function (catalog) {
            if (!updatedCatalogIds.has(catalog.Id)) {
                payloads.push({
                    catalogId: catalog.Id,
                    contextsToRemove: {
                        companyLocationIds: [updatedLocation.Id],
                    },
                });
            }
        });
        return {
            catalogs: payloads,
        };
    };
    var buildRolesToAssignPayloads = function (updatedLocation, salesRepId, salesRepName) {
        var _a, _b, _c, _d;
        var originalContactIds = new Set((_a = originalLocationDetals === null || originalLocationDetals === void 0 ? void 0 : originalLocationDetals.ContactPersons) === null || _a === void 0 ? void 0 : _a.map(function (c) { return c.Id; }));
        var newContacts = ((_b = updatedLocation.ContactPersons) === null || _b === void 0 ? void 0 : _b.filter(function (c) { return !originalContactIds.has(c.Id); })) || [];
        if ((newContacts === null || newContacts === void 0 ? void 0 : newContacts.length) === 0)
            return null;
        var newContact = newContacts[0];
        return {
            companyId: companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id,
            companyLocationId: updatedLocation === null || updatedLocation === void 0 ? void 0 : updatedLocation.Id,
            salesRepId: salesRepId,
            salesRepName: salesRepName,
            companyContactRoleId: (_c = props === null || props === void 0 ? void 0 : props.CompanyCustomerRoleId) !== null && _c !== void 0 ? _c : "",
            customerId: ((_d = newContact.Id) === null || _d === void 0 ? void 0 : _d.startsWith("gid://shopify/Customer/")) ? newContact.Id : "gid://shopify/Customer/".concat(newContact.Id),
        };
    };
    var updateLocalCompanyStates = function (updateKey) {
        var _a;
        setCompanyDetails(function (prev) {
            var _a;
            var updated = __assign({}, prev);
            switch (updateKey) {
                case "Note":
                    updated.Note = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Note;
                    break;
                case "ExternalId":
                    updated.ExternalId = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ExternalId;
                    break;
                case "ShippingAddress":
                case "BillingAddress":
                    var locationIndex = (_a = updated === null || updated === void 0 ? void 0 : updated.Locations) === null || _a === void 0 ? void 0 : _a.findIndex(function (loc) { return (loc === null || loc === void 0 ? void 0 : loc.Id) === (locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Id); });
                    if (locationIndex !== -1) {
                        var updatedLocation = __assign({}, updated.Locations[locationIndex]);
                        if (updateKey === "ShippingAddress") {
                            updatedLocation.ShippingAddress = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ShippingAddress;
                        }
                        else {
                            updatedLocation.BillingAddress = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.BillingAddress;
                        }
                        updated.Locations[locationIndex] = updatedLocation;
                    }
                    break;
                case "ContactPersons":
                    replaceLocationKey(updated, "ContactPersons", locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ContactPersons);
                    break;
                case "Catalogs":
                    replaceLocationKey(updated, "Catalogs", locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Catalogs);
                    break;
                case "BuyerExperienceConfiguration":
                    replaceLocationKey(updated, "BuyerExperienceConfiguration", locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.BuyerExperienceConfiguration);
                    break;
                case "TaxExempt":
                    replaceLocationKey(updated, "TaxExempt", locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.TaxExempt);
                    replaceLocationKey(updated, "TaxRegistrationId", locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.TaxRegistrationId);
                    break;
                default:
                    break;
            }
            return updated;
        });
        (_a = props === null || props === void 0 ? void 0 : props.setSingleCompanyDetails) === null || _a === void 0 ? void 0 : _a.call(props, function (prev) {
            var _a;
            var updated = __assign({}, prev);
            var locIndex = (_a = updated === null || updated === void 0 ? void 0 : updated.Locations) === null || _a === void 0 ? void 0 : _a.findIndex(function (loc) { return (loc === null || loc === void 0 ? void 0 : loc.Id) === (locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Id); });
            if (locIndex !== -1) {
                var updatedLoc = __assign({}, updated.Locations[locIndex]);
                switch (updateKey) {
                    case "ShippingAddress":
                        updatedLoc.ShippingAddress = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ShippingAddress;
                        break;
                    case "BillingAddress":
                        updatedLoc.BillingAddress = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.BillingAddress;
                        break;
                    case "ContactPersons":
                        updatedLoc.ContactPersons = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ContactPersons;
                        break;
                    case "Catalogs":
                        updatedLoc.Catalogs = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Catalogs;
                        break;
                    case "BuyerExperienceConfiguration":
                        updatedLoc.BuyerExperienceConfiguration = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.BuyerExperienceConfiguration;
                        break;
                    case "TaxExempt":
                        updatedLoc.TaxExempt = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.TaxExempt;
                        updatedLoc.TaxRegistrationId = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.TaxRegistrationId;
                        break;
                    case "ExternalId":
                        updatedLoc.ExternalId = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.ExternalId;
                        break;
                    case "Note":
                        updatedLoc.Note = locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Note;
                        break;
                    default:
                        break;
                }
                updated.Locations[locIndex] = updatedLoc;
            }
            return updated;
        });
    };
    // Helper to replace a key inside the correct location
    var replaceLocationKey = function (company, key, value) {
        var _a;
        var _b;
        var index = (_b = company === null || company === void 0 ? void 0 : company.Locations) === null || _b === void 0 ? void 0 : _b.findIndex(function (l) { return l.Id === locationDetals.Id; });
        if (index !== -1) {
            var updatedLoc = __assign(__assign({}, company.Locations[index]), (_a = {}, _a[key] = value, _a));
            company.Locations[index] = updatedLoc;
        }
    };
    // Update existing location
    var mapUpdateLocationPayload = function (updateKey, locationData) {
        var _a, _b, _c;
        var _d = getLoggedInRepDetailsFromSession(), CustomerId = _d.CustomerId, SalesRepName = _d.SalesRepName; //user credentials
        var repName = SalesRepName;
        var salesRepId = CustomerId;
        switch (updateKey) {
            case "Note":
                return {
                    companyLocationId: locationData.Id,
                    input: {
                        note: locationData.Note,
                    },
                };
            case "ExternalId":
                return {
                    companyLocationId: locationData.Id,
                    input: {
                        externalId: locationData.ExternalId,
                    },
                };
            case "ShippingAddress":
                return {
                    addressData: (locationData === null || locationData === void 0 ? void 0 : locationData.ShippingAddress) ? getAddressPayload(locationData === null || locationData === void 0 ? void 0 : locationData.ShippingAddress) : {},
                    addressTypes: ["SHIPPING"],
                    locationId: locationData === null || locationData === void 0 ? void 0 : locationData.Id,
                    companyId: (_a = companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id) !== null && _a !== void 0 ? _a : "",
                    salesRepId: salesRepId,
                    salesRepName: repName,
                };
            case "BillingAddress":
                return {
                    addressData: (locationData === null || locationData === void 0 ? void 0 : locationData.BillingAddress) ? getAddressPayload(locationData === null || locationData === void 0 ? void 0 : locationData.BillingAddress) : {},
                    addressTypes: ["BILLING"],
                    locationId: locationData.Id,
                    companyId: (_b = companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id) !== null && _b !== void 0 ? _b : "",
                    salesRepId: salesRepId,
                    salesRepName: repName,
                };
            case "ContactPersons":
                return buildRolesToAssignPayloads(locationData, salesRepId, repName);
            case "Catalogs":
                return buildCatalogUpdatePayloads(locationData);
            case "BuyerExperienceConfiguration":
                return {
                    companyLocationId: locationData.Id,
                    input: {
                        paymentTermsTemplateId: (_c = locationData.BuyerExperienceConfiguration) === null || _c === void 0 ? void 0 : _c.PaymentTermsId,
                    },
                };
            case "TaxExempt":
                return {
                    companyLocationId: locationData === null || locationData === void 0 ? void 0 : locationData.Id,
                    taxExempt: locationData === null || locationData === void 0 ? void 0 : locationData.TaxExempt,
                    taxRegistrationId: locationData === null || locationData === void 0 ? void 0 : locationData.TaxRegistrationId,
                };
            default:
                console.error("Unknown update key provided:", updateKey);
                return {};
        }
    };
    var handleErrorMessages = function (updateKey) {
        switch (updateKey) {
            case "Note":
                return "Location notes";
            case "ExternalId":
                return "Location ID";
            case "ShippingAddress":
                return "Shipping address";
            case "BillingAddress":
                return "Billing address";
            case "ContactPersons":
                return "Customer";
            case "Catalogs":
                return "Assigned catalogs";
            case "BuyerExperienceConfiguration":
                return "Payment terms";
            case "TaxExempt":
                return "Taxes";
            default:
                console.error("Unknown update key provided:", updateKey);
                return "Field";
        }
    };
    var handleSaveLocation = function (updateKey) { return __awaiter(_this, void 0, void 0, function () {
        var result, fieldLabel;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsSavingLocation(updateKey);
                    return [4 /*yield*/, updateCompanyLocationBL(updateKey)];
                case 1:
                    result = _c.sent();
                    setIsSavingLocation("");
                    fieldLabel = handleErrorMessages(updateKey);
                    if (!(result === true)) return [3 /*break*/, 5];
                    setUpdatedLocationArray(function (prev) {
                        var _a;
                        return (__assign(__assign(__assign({}, prev), (_a = {}, _a[updateKey] = false, _a)), (updateKey === "TaxExempt" && { TaxRegistrationId: false })));
                    });
                    if (!(updateKey === "ContactPersons")) return [3 /*break*/, 3];
                    setIsHovered(null);
                    return [4 /*yield*/, dispatch(getSalesRepBaseData())];
                case 2:
                    _c.sent();
                    _c.label = 3;
                case 3: 
                // data=56 list + Redux b2bCompaniesData: refresh after any location save so B2B order picker sees updated assignedLocations / addresses
                return [4 /*yield*/, ((_a = props === null || props === void 0 ? void 0 : props.refreshCompanyList) === null || _a === void 0 ? void 0 : _a.call(props))];
                case 4:
                    // data=56 list + Redux b2bCompaniesData: refresh after any location save so B2B order picker sees updated assignedLocations / addresses
                    _c.sent();
                    updateLocalCompanyStates(updateKey); // ✅ Call here
                    settriggerSnackbar({ msg: "".concat(fieldLabel, " updated successfully."), open: true, severity: "success" });
                    return [2 /*return*/, true];
                case 5:
                    if ((_b = result === null || result === void 0 ? void 0 : result.message) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes("external id")) {
                        fieldLabel = "Location ID";
                    }
                    settriggerSnackbar({
                        msg: "Failed to update ".concat(fieldLabel, ". ").concat((result === null || result === void 0 ? void 0 : result.message) || ""),
                        open: true,
                        severity: result === null || result === void 0 ? void 0 : result.type,
                    });
                    return [2 /*return*/, false];
            }
        });
    }); };
    var updateCompanyLocationBL = function (updateKey) { return __awaiter(_this, void 0, void 0, function () {
        var resourceNo, payload, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    resourceNo = getResourceNoForUpdateKey(updateKey);
                    if (!resourceNo) {
                        return [2 /*return*/, { type: "warning", message: "Invalid update operation." }];
                    }
                    payload = mapUpdateLocationPayload(updateKey, locationDetals);
                    if (!payload) {
                        return [2 /*return*/, { type: "warning", message: "Failed to prepare update request." }];
                    }
                    return [4 /*yield*/, updateCompanyLocationAction(payload, resourceNo)(dispatch)];
                case 1:
                    result = _a.sent();
                    if (result === true) {
                        return [2 /*return*/, true];
                    }
                    else if (typeof result === "string") {
                        return [2 /*return*/, { type: "error", message: result }];
                    }
                    else {
                        return [2 /*return*/, { type: "error", message: "Unknown server error occurred." }];
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, { type: "error", message: "Unexpected error occurred while updating company location." }];
                case 3:
                    setTimeout(function () {
                        settriggerSnackbar({ msg: "", open: false });
                    }, 3000);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleCreateLocationSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id) || (locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Id)) {
                        return [2 /*return*/];
                    }
                    if (!(locationDetals === null || locationDetals === void 0 ? void 0 : locationDetals.Name)) {
                        settriggerSnackbar({ msg: "Location name is required. Please enter a name before creating the location.", open: true, severity: "warning" });
                        return [2 /*return*/];
                    }
                    setIsCreatingLocation(true);
                    return [4 /*yield*/, createCompanyLocationHndle(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id)];
                case 1:
                    result = _b.sent();
                    if (!((result === null || result === void 0 ? void 0 : result.status) === "success")) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(getSalesRepBaseData())];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, ((_a = props === null || props === void 0 ? void 0 : props.refreshCompanyList) === null || _a === void 0 ? void 0 : _a.call(props))];
                case 3:
                    _b.sent();
                    props === null || props === void 0 ? void 0 : props.BackBtnHandle();
                    setTimeout(function () {
                        setlocationModal("");
                        settriggerSnackbar({ msg: "", open: false });
                        setIsCreatingLocation(false);
                    }, 3000);
                    return [3 /*break*/, 5];
                case 4:
                    settriggerSnackbar({ msg: result.message, open: true, severity: result.status });
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // Create new location
    var mapCreateLocationPayload = function (companyId, locationData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var _k = getLoggedInRepDetailsFromSession(), CustomerId = _k.CustomerId, SalesRepName = _k.SalesRepName; //user credentials
        var repName = SalesRepName;
        var salesRepId = CustomerId;
        return {
            companyId: companyId,
            companyName: (_a = companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Name) !== null && _a !== void 0 ? _a : "",
            salesRepId: salesRepId,
            salesRepName: repName,
            locationInput: {
                name: locationData === null || locationData === void 0 ? void 0 : locationData.Name,
                note: locationData === null || locationData === void 0 ? void 0 : locationData.Note,
                shippingAddress: (locationData === null || locationData === void 0 ? void 0 : locationData.ShippingAddress) ? getAddressPayload(locationData === null || locationData === void 0 ? void 0 : locationData.ShippingAddress) : {},
                billingAddress: (locationData === null || locationData === void 0 ? void 0 : locationData.BillingAddress) ? getAddressPayload(locationData === null || locationData === void 0 ? void 0 : locationData.BillingAddress) : {},
                billingSameAsShipping: locationData === null || locationData === void 0 ? void 0 : locationData.BillingSameAsShipping,
                buyerExperienceConfiguration: {
                    paymentTermsTemplateId: (_b = locationData.BuyerExperienceConfiguration) === null || _b === void 0 ? void 0 : _b.PaymentTermsId,
                },
                externalId: locationData === null || locationData === void 0 ? void 0 : locationData.ExternalId,
                taxExempt: locationData === null || locationData === void 0 ? void 0 : locationData.TaxExempt,
                taxRegistrationId: locationData === null || locationData === void 0 ? void 0 : locationData.TaxRegistrationId,
            },
            catalogs: ((_c = locationData === null || locationData === void 0 ? void 0 : locationData.Catalogs) === null || _c === void 0 ? void 0 : _c.map(function (catalog) { return ({
                catalogId: catalog === null || catalog === void 0 ? void 0 : catalog.Id,
                contextsToAdd: {
                    companyLocationIds: [],
                },
            }); })) || [],
            rolesToAssign: ((_d = locationData === null || locationData === void 0 ? void 0 : locationData.ContactPersons) === null || _d === void 0 ? void 0 : _d.length)
                ? {
                    companyContactRoleId: (_e = props === null || props === void 0 ? void 0 : props.CompanyCustomerRoleId) !== null && _e !== void 0 ? _e : "",
                    customerId: ((_g = (_f = locationData.ContactPersons[0]) === null || _f === void 0 ? void 0 : _f.Id) === null || _g === void 0 ? void 0 : _g.startsWith("gid://shopify/Customer/"))
                        ? (_h = locationData.ContactPersons[0]) === null || _h === void 0 ? void 0 : _h.Id
                        : "gid://shopify/Customer/".concat((_j = locationData.ContactPersons[0]) === null || _j === void 0 ? void 0 : _j.Id),
                }
                : null,
        };
    };
    var createCompanyLocationHndle = function (companyId) { return __awaiter(_this, void 0, void 0, function () {
        var payload, resourceNo, result, errMsg, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    payload = mapCreateLocationPayload(companyId, locationDetals);
                    resourceNo = "13";
                    if (!payload) {
                        return [2 /*return*/, { status: "warning", message: "Invalid or missing location data." }];
                    }
                    return [4 /*yield*/, createCompanyLocationAction(payload, resourceNo)];
                case 1:
                    result = _b.sent();
                    if (result === true) {
                        settriggerSnackbar({ msg: "Company location created successfully!", open: true, severity: "success" });
                        return [2 /*return*/, {
                                status: "success",
                                locationInput: payload.locationInput,
                            }];
                    }
                    else {
                        setIsCreatingLocation(false);
                        errMsg = typeof result === "string" ? result : "Failed to create company location.";
                        return [2 /*return*/, { status: "error", message: errMsg }];
                    }
                    return [3 /*break*/, 4];
                case 2:
                    _a = _b.sent();
                    setIsCreatingLocation(false);
                    return [2 /*return*/, {
                            status: "error",
                            message: "Unexpected error occurred while creating company location.",
                        }];
                case 3:
                    setTimeout(function () {
                        settriggerSnackbar({ msg: "", open: false });
                    }, 3000);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSaveCompanyNote = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id)) {
                        settriggerSnackbar({ msg: "Company ID missing. Cannot update note.", open: true, severity: "warning" });
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateCompanyNote(companyDetails === null || companyDetails === void 0 ? void 0 : companyDetails.Id, editedCompanyNote)];
                case 1:
                    result = _b.sent();
                    if (!(result.status === "success")) return [3 /*break*/, 3];
                    setCompanyDetails(function (prev) { return (__assign(__assign({}, prev), { Note: editedCompanyNote })); });
                    props === null || props === void 0 ? void 0 : props.setSingleCompanyDetails(function (prev) { return (__assign(__assign({}, prev), { Note: editedCompanyNote })); });
                    return [4 /*yield*/, ((_a = props === null || props === void 0 ? void 0 : props.refreshCompanyList) === null || _a === void 0 ? void 0 : _a.call(props))];
                case 2:
                    _b.sent();
                    settriggerSnackbar({ msg: "Company note updated successfully.", open: true, severity: "success" });
                    return [3 /*break*/, 4];
                case 3:
                    settriggerSnackbar({ msg: result.message, open: true, severity: result.status });
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var updateCompanyNote = function (companyId, note) { return __awaiter(_this, void 0, void 0, function () {
        var payload, resourceNo, result, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    if (!note.trim()) {
                        return [2 /*return*/, { status: "warning", message: "Cannot update note: Note content is empty." }];
                    }
                    payload = { companyId: companyId, input: { note: note } };
                    resourceNo = "5";
                    setIsUpdatingCompanyNote(true);
                    return [4 /*yield*/, updateCompanyNoteAction(payload, resourceNo)];
                case 1:
                    result = _b.sent();
                    setIsUpdatingCompanyNote(false);
                    if (result === true) {
                        return [2 /*return*/, { status: "success" }];
                    }
                    else {
                        return [2 /*return*/, { status: "error", message: typeof result === "string" ? result : "Failed to update company note." }];
                    }
                    return [3 /*break*/, 4];
                case 2:
                    _a = _b.sent();
                    setIsUpdatingCompanyNote(false);
                    return [2 /*return*/, { status: "error", message: "Unexpected error occurred while updating company note." }];
                case 3:
                    setTimeout(function () {
                        settriggerSnackbar({ msg: "", open: false });
                    }, 3000);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return {
        t: t,
        customerArray: customerArray,
        paymentTermOptions: paymentTermOptions,
        catalogHoveredIconIndex: catalogHoveredIconIndex,
        isHovered: isHovered,
        addressModal: addressModal,
        isEditAddressModal: isEditAddressModal,
        newCustomerModal: newCustomerModal,
        addressType: addressType,
        companyDetails: companyDetails,
        catalogProduct: catalogProduct,
        locationModal: locationModal,
        locationDetals: locationDetals,
        setCatalogHoveredIconIndex: setCatalogHoveredIconIndex,
        setLocationDetals: setLocationDetals,
        setIsHovered: setIsHovered,
        handleChange: handleChange,
        handleCatalogChange: handleCatalogChange,
        handleRemoveCatalog: handleRemoveCatalog,
        closeAddressModal: closeAddressModal,
        handleNewCustomerModal: handleNewCustomerModal,
        addressValidationCheckForShipping: addressValidationCheckForShipping,
        getCustomerAddressData: getCustomerAddressData,
        handleCloseSnackbar: handleCloseSnackbar,
        settriggerSnackbar: settriggerSnackbar,
        triggerSnackbar: triggerSnackbar,
        handleAddressModal: handleAddressModal,
        addressValidationCheckForBilling: addressValidationCheckForBilling,
        handleLocationClick: handleLocationClick,
        CatalogProductCountList: CatalogProductCountList,
        handlePaymentTermChange: handlePaymentTermChange,
        handleCompanyNoteChange: handleCompanyNoteChange,
        handleAddCustomer: handleAddCustomer,
        handleRemoveCustomer: handleRemoveCustomer,
        handleResetLocationCards: handleResetLocationCards,
        shouldShowSaveCancelButtonsForKey: shouldShowSaveCancelButtonsForKey,
        isSavingLocation: isSavingLocation,
        handleSaveLocation: handleSaveLocation,
        handleResetCompanyNote: handleResetCompanyNote,
        handleSaveCompanyNote: handleSaveCompanyNote,
        shouldShowNoteSaveReset: shouldShowNoteSaveReset,
        isUpdatingCompanyNote: isUpdatingCompanyNote,
        editedCompanyNote: editedCompanyNote,
        handleCreateLocationSave: handleCreateLocationSave,
        handleResetCreateLocation: handleResetCreateLocation,
        isCreatingLocation: isCreatingLocation,
        BackToCompanyPage: BackToCompanyPage,
        shouldShowTaxSaveButtons: shouldShowTaxSaveButtons,
        handleCheckboxChange: handleCheckboxChange,
        originalLocationDetals: originalLocationDetals,
        isFormChanged: isFormChanged,
        setAllowResetFormData: setAllowResetFormData,
        allowResetFormData: allowResetFormData,
        getDefaultAddress: getDefaultAddress,
        isDisabledContactPersons: isDisabledContactPersons,
    };
}
